export  const RESULT_FILTER_MODAL = 'RESULT_FILTER_MODAL';
export  const RESULT_RATING_MODAL = 'RESULT_RATING_MODAL';
export const HAS_SUBSCRIPTION_KEY = 'subscription@insaider';